import $ from "jquery";

export const miHeightProjectenQuery = () => {
  const parentQuery = {
    reguliere: ".mi-projecten-reguliere__container",
    mechanisch: ".mi-projecten-mechanisch__container",
  };
  const init = () => {
    try {
      if (window.innerWidth >= 768) {
        exec();
      }
    } catch (err) {
      console.error(err);
    }
  };
  const exec = () => {
    let galleryHeightMech =
      $(parentQuery.mechanisch + " .mi-projecten-query__gallery ul").height() ??
      584;
    let galleryHeightReg =
      $(parentQuery.reguliere + " .mi-projecten-query__gallery ul").height() ??
      584;

    // Change thumbnail image height
    $(parentQuery.mechanisch + " .mi-projecten-query__thumbnail img").height(
      galleryHeightMech -
        $(parentQuery.mechanisch + " .mi-projecten-query__main").outerHeight()
    );

    // Change thumbnail image height
    $(parentQuery.reguliere + " .mi-projecten-query__thumbnail img").height(
      galleryHeightReg -
        $(parentQuery.reguliere + " .mi-projecten-query__main").outerHeight()
    );
  };
  init();
};
